<div >
  <div *ngIf="CanShow === 1 ">
    <div class="row card-deck">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">
        <section id="paging" class="mb-3" *ngIf="CanShow === 1 ">

          <div class="row">
            <div class="col-12">
              <div *ngIf="CurrentActorProfessionalReferencesInfoController">
                <div class="card">
                  <div class="card-header  wh-header">
                    <div class="row ">
                      <div class="col-md-10 pink">
                        <i class="fa fa-users"></i> References
                      </div>
                      <div class="col-md-2 float-right" *ngIf="CanEdit === 1 ">
                        <a (click)="openNewContent()" class="nav-link-hand btn btn-primary"><span class="badge badge-pink"> <i class="fa fa-plus"></i></span>Add New</a>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="card-block">
                      <div *ngFor="let l of CurrentActorProfessionalReferencesInfoController">
                        <div class="media mb-1">
                          <div class="media-body">
                            <h4 class="font-medium-1 mt-1 mb-1">{{l.ContactPersonTitle }}</h4>
                            <p class="text-muted font-small-3 mb-1 pink">{{l.FacilityName}}</p>
                            <p class="text-muted font-small-2">Contact Person: <span class="badge badge-pink">{{l.ContactPerson}}</span></p>
                          </div>
                          <div class="mt-1">
                            <div class="row">
                              <!--<div class="float-left">-->
                              <a (click)="OpenDetailContent(l.ProfessionalReferenceCode)" class="nav-link-hand">
                                <span class="badge">
                                  <i class="fa fa-list grey"></i>
                                </span>
                              </a>
                              <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand">
                                <span class="badge">
                                  <i class="fa fa-file grey"></i>
                                </span>
                              </a>
                              <a (click)="del_(l.ProfessionalReferenceCode)" *ngIf="CanEdit === 1 " class="nav-link-hand">
                                <span class="badge">
                                  <i class="fa fa-times grey"></i>
                                </span>
                              </a>
                              <!--</div>-->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="row">
            <div class="col-sm-12">
              <data-grid *ngIf="CurrentActorProfessionalReferencesInfoController"
                         [columns]="columns" [data]="CurrentActorProfessionalReferencesInfoController"
                         [gridbtns]="gridbtns"
                         [hdrbtns]="hdrbtns"
                         [sort]="sorting"
                         (btnclick)="gridaction($event)">
              </data-grid>

            </div>
          </div>-->
        </section>
      </div>
    </div>
  </div>

  <!--Paging dataTable starts-->
  <div *ngIf="CanShowRegistryView === 1 && CurrentActorProfessionalReferencesInfoController && CurrentActorProfessionalReferencesInfoController.length >0 ">
    <div class="row card-deck">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">
        <div class="row">
          <div class="col-12">
            <div *ngIf="CurrentActorProfessionalReferencesInfoController">
              <div class="card">
                <div class="card-header   wh-header">
                  <div class="row">
                    <div class="col-md-10 pink">
                      <i class="fa fa-users"></i> REFERENCES
                    </div>

                  </div>
                </div>
                <div class="card-body">
                  <div class="card-block">
                    <div *ngFor="let l of CurrentActorProfessionalReferencesInfoController">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label>{{l.ContactPersonTitle }}</label>
                            <p>{{l.FacilityName}}</p>
                            <p>Contact Person: <span class="badge badge-pink">{{l.ContactPerson}}</span></p>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
